import React from 'react'

const TEXT = { saving: 'Сохранение…', saved: 'Сохранено', error: 'Ошибка сохранения' }

/**
 * SaveStatus — quiet autosave indicator for the topbar. Renders nothing
 * when idle; otherwise a separator dot + status text.
 */
export function SaveStatus({ state }) {
  if (state === 'idle' || !state) return null
  return (
    <>
      <span className="topbar-sep">·</span>
      <span className="topbar-status">{TEXT[state]}</span>
    </>
  )
}
